import * as tracker from '../../_core/common/eventTracking/tracker';
import { getUpgradeDataTrackingProperties } from '../../ums/utils';
export const trackViewedRequestSeatButton = ({
  upgradeData
}) => {
  tracker.track('interaction', Object.assign({
    action: 'viewed request seat'
  }, getUpgradeDataTrackingProperties(upgradeData)));
};
export const trackClickedRequestSeatButton = ({
  upgradeData
}) => {
  const trackingProperties = getUpgradeDataTrackingProperties(upgradeData);
  tracker.track('interaction', Object.assign({
    action: 'clicked request seat'
  }, trackingProperties));
  if (upgradeData.pointType) {
    tracker.track('interaction', Object.assign({
      action: 'clicked upgrade point'
    }, trackingProperties));
  }
};